import React from 'react';
import Autosuggest from 'react-autosuggest';
import { Icon } from 'ui';

class RelatedUrlMappingAutoSuggest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      suggestions: [],
    };
    this.onSuggestionsFetchRequested =
      this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onSuggestionsClearRequested =
      this.onSuggestionsClearRequested.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  filterSuggestions(value) {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.props.learningContent.filter(assignable =>
          (assignable.title || 'Untitled Lesson')
            .toLowerCase()
            .includes(inputValue.toLowerCase()),
        );
  }

  onChange(event, { newValue }) {
    this.setState({
      value: newValue,
    });
  }

  onSuggestionsFetchRequested({ value }) {
    this.setState({
      suggestions: this.filterSuggestions(value),
    });
  }

  getSuggestionValue(suggestion) {
    return suggestion.title;
  }

  onSuggestionSelected(e, { suggestion }) {
    this.props.addNewMappingFromSuggestion(suggestion);
    this.setState({ value: '' });
  }

  onSuggestionsClearRequested() {
    this.setState({
      suggestions: [],
      value: '',
    });
  }

  renderSuggestion(suggestion) {
    return (
      <div>
        {suggestion.type === 'LearningPaths::Path' && (
          <span>
            <Icon name="path" className="mr-4" />
          </span>
        )}
        {suggestion.title}
      </div>
    );
  }

  onKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  render() {
    const inputProps = {
      value: this.state.value,
      onChange: this.onChange,
      placeholder: this.props.placeholder,
      onKeyDown: this.onKeyDown,
    };

    return (
      <Autosuggest
        className="NewInput NewInput--white NewInput--fw mb-16"
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
        focusFirstSuggestion
      />
    );
  }
}

export default RelatedUrlMappingAutoSuggest;
